<template>
	<div>
		<h2>Наши партнеры</h2>	
		<div class="row">
			
				<app-alert v-if="load" show> </app-alert>	
				<div class="col col-xl-3 col-md-5" 				
				     v-for="(item) in items" :key = "item.id"
				     >
				     <app-card :item = item ></app-card>
				
				</div>
		</div>		
	</div>
</template>

<script>
import Vue from 'vue'


 import AppCard  from "../components/AppCard.vue"	
 import AppModal from "../components/AppModal.vue"
 import AppAlert from "../components/AppAlert.vue"

	export default {
		created(){ 
				Vue.http.get(this.name + '.php')
					.then(response => {
						console.log(response.data)
						this.items = response.data.rows
						this.load = false
					},
						error =>{
							console.log(error)
						}
					)
					//this.items = Serv
					//this.load = false

				
			
		},
		data(){
			return{
				items: [],
				name: this.$route.name,
				load:true,
				logon:true
				
			}
		},
		components:{
			AppCard,
			AppAlert,
			AppModal
		}
		
	};

</script>

<style scoped>
	.row{
		justify-content: center;
		padding-right: 20px;
	}

	.col{
		border:1px solid black;
		border-radius: 5px;
		margin:10px;
		padding: 5px;
		text-align:center;
		display: flex;
    	justify-content: space-between;
    	max-width: 250px

	}
	.media{
		flex-wrap: wrap;
	    align-items: center;
	    margin: 0px 30px;
	    justify-content: center;
	}
	.media p{
		text-align: justify;
	}
	.media img{
		width: 350px;
		height: 250px;
		margin: 10px;
	}

	h2{
		text-align: center;
	}


	@media(max-width: 560px){
		.media img{
			    width: 280px;
			    height: 200px;
			}
		.media{
				margin-right: 0px;

		}
	}
</style>